import { render, staticRenderFns } from "./ExpenseAdjustment.vue?vue&type=template&id=2e74320a&"
import script from "./ExpenseAdjustment.vue?vue&type=script&lang=js&"
export * from "./ExpenseAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e74320a')) {
      api.createRecord('2e74320a', component.options)
    } else {
      api.reload('2e74320a', component.options)
    }
    module.hot.accept("./ExpenseAdjustment.vue?vue&type=template&id=2e74320a&", function () {
      api.rerender('2e74320a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ExpenseAdjustment.vue"
export default component.exports